export const QUESTION_TYPE_CHAT = {
  SIMPLE: 'simple',
  DETAIL: 'detail',
};

export enum QuestionResponseFormat {
  PLAIN_TEXT = 'PLAIN_TEXT',
  JSON_AST = 'JSON_AST',
}

// old: true
// 旧数据，除了在聊天记录列表里展示外，不在消息反馈选项里展示。
export const FEEDBACK_MAP = {
  good: [
    {
      value: 'clear_content',
      label: 'chat_feedback.good.clear_content',
    },
    {
      value: 'needed_info',
      label: 'chat_feedback.good.needed_info',
    },
    {
      value: 'problem_solved',
      label: 'chat_feedback.good.problem_solved',
    },
    {
      value: 'quick_response',
      label: 'chat_feedback.good.quick_response',
    },
    {
      value: 'unexpected_insights',
      label: 'chat_feedback.good.unexpected_insights',
    },
    {
      value: 'accuracy',
      label: 'chat_feedback.good.accuracy',
      old: true,
    },
    {
      value: 'credibility',
      label: 'chat_feedback.good.credibility',
      old: true,
    },
    {
      value: 'assistance',
      label: 'chat_feedback.good.assistance',
      old: true,
    },
    {
      value: 'efficiency',
      label: 'chat_feedback.good.efficiency',
      old: true,
    },
    {
      value: 'entertainment',
      label: 'chat_feedback.good.entertainment',
      old: true,
    },
  ],
  bad: [
    {
      value: 'insufficient_info',
      label: 'chat_feedback.bad.insufficient_info',
    },
    {
      value: 'misaligned_intent',
      label: 'chat_feedback.bad.misaligned_intent',
    },
    {
      value: 'unclear_terms',
      label: 'chat_feedback.bad.unclear_terms',
    },
    {
      value: 'inappropriate_length',
      label: 'chat_feedback.bad.inappropriate_length',
    },
    {
      value: 'outdated_info',
      label: 'chat_feedback.bad.outdated_info',
    },
    {
      value: 'inaccuracy',
      label: 'chat_feedback.bad.inaccuracy',
      old: true,
    },
    {
      value: 'unhelpful',
      label: 'chat_feedback.bad.unhelpful',
      old: true,
    },
    {
      value: 'harmful',
      label: 'chat_feedback.bad.harmful',
      old: true,
    },
    {
      value: 'tooShort',
      label: 'chat_feedback.bad.tooShort',
      old: true,
    },
    {
      value: 'outdated',
      label: 'chat_feedback.bad.outdated',
      old: true,
    },
  ],
};

export const SUPPORT_I18N_LANGUAGES = ['en', 'ja', 'zh-Hans', 'ko', 'vi', 'pt', 'pt-BR', 'id', 'ne', 'es'];

/**
 * 将 i18n 支持的语言转换成 FAQ 树接口支持的语言
 */
export const I18N_LANG_MAP: Record<string, string> = {
  en: 'en', // 英语
  ja: 'ja', // 日语
  'zh-Hans': 'zh', // 中文（简体）
  ko: 'ko', // 韩语
  vi: 'vi', // 越南语
  pt: 'pt', // 葡萄牙语
  'pt-BR': 'pt-BR', // 巴西语
  id: 'id', // 印度尼西亚语
  ne: 'ne', // 尼泊尔语
  es: 'es', // 西班牙语
};
